import { atom } from "recoil";
import { ICameraType1 } from "../types";
export const addStateCameraType1 = atom({
  key: "addStateCameraType1",
  default: false,
});
export const editStateCameraType1 = atom({
  key: "editStateCameraType1",
  default: false,
});
export const rowEditCameraType1 = atom<ICameraType1 | undefined>({
  key: "rowEditCameraType1",
  default: undefined,
});

export const selectedRowsStateCameraType1 = atom<ICameraType1[]>({
  key: "selectedRowsStateCameraType1",
  default: [],
});

export const cameraType1FilterText = atom({
  key: "cameraType1FilterText",
  default: "",
});

export const cameraType1Fetching = atom({
  key: "cameraType1Fetching",
  default: true,
});

export const cameraType1ReFetching = atom({
  key: "cameraType1ReFetching",
  default: false,
});
